import { useEffect, useState } from 'react';
import { readEffectiveScrollHeaderOffsetPixels } from '../lib/scrollToSectionStart';

/** Show a section scroll cue while that section is still on screen; hide after scrolling past it. */
export function useScrollCueVisibility(sectionId) {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if (!sectionId) {
      return undefined;
    }

    const evaluate = () => {
      const sectionElement = document.getElementById(sectionId);
      if (!sectionElement) {
        setVisible(true);
        return;
      }

      const headerOffset = readEffectiveScrollHeaderOffsetPixels(sectionElement);
      const viewportHeight = window.innerHeight;
      const sectionRect = sectionElement.getBoundingClientRect();

      const sectionStillOnScreen =
        sectionRect.bottom > headerOffset + 32 && sectionRect.top < viewportHeight - 24;
      const scrolledPastSection = sectionRect.bottom < headerOffset + 16;

      setVisible(sectionStillOnScreen && !scrolledPastSection);
    };

    evaluate();
    window.addEventListener('scroll', evaluate, { passive: true });
    window.addEventListener('resize', evaluate);
    return () => {
      window.removeEventListener('scroll', evaluate);
      window.removeEventListener('resize', evaluate);
    };
  }, [sectionId]);

  return visible;
}
